import { Link } from 'react-router-dom';
import { getTopRatedComics } from '@/mocks/comics';

export default function TopRated() {
  const topComics = getTopRatedComics(6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            <i className="ri-trophy-line text-accent-500 mr-2"></i>
            评分排行榜
          </h2>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="space-y-3">
          {topComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-sm md:text-base font-bold ${
                index === 0
                  ? 'bg-accent-500 text-background-50'
                  : index === 1
                  ? 'bg-secondary-500 text-background-50'
                  : index === 2
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="flex-shrink-0 w-12 h-16 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 色漫屋漫画封面`}
                  title={`${comic.title} - 色漫屋在线漫画`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm md:text-base font-bold">{comic.rating}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                  {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} 次阅读
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}